export enum PRODUCT_TYPE_GROUP {
  PRODUCTS = 0,
  OUTFITS = 1,
}
